'use client';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import Typography from '@mui/material/Typography';
import { useAppContext } from '../../contexts/app';
import SidebarActiveGroups from './sidebar-active-groups';
import SidebarGroupActions from './sidebar-group-actions';

const SidebarWelcome = () => {
  const { isLoggedIn, city } = useAppContext();
  const cityName = city?.name;

  const message = isLoggedIn
    ? `Join a group${cityName ? ` in ${cityName}` : ''} to see their rides on your calendar and get updates when new events are posted.`
    : `Groups organize regular rides and share updates with members. Sign up to join a group${cityName ? ` in ${cityName}` : ''} and never miss a ride.`;

  return (
    <>
      <Divider />
      <List
        dense
        subheader={
          <ListSubheader
            sx={{
              fontSize: '0.75rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              lineHeight: '32px',
            }}
          >
            Groups
          </ListSubheader>
        }
      >
        <Box sx={{ px: 2, pb: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {message}
          </Typography>
        </Box>
        <SidebarActiveGroups />
        <SidebarGroupActions browseLabel="Browse All Groups" />
      </List>
    </>
  );
};

export default SidebarWelcome;
